import { interpolateRgb } from 'd3';
import { ScenarioDeltaGreen100, ScenarioDeltaGreen400 } from '@src/utils/colors';

export const BETA_BAR_SIZE = 100;
export const QUANTITY_BAR_SIZE = 20;

export const CHART_SYNC_ID = 'sync';
// The wide left margin holds the beta chart's "Baseline Performance" label.
export const CHART_MARGIN = { top: 5, right: 20, left: 52, bottom: 5 };
// Extra top space for the value label above the tallest bar.
export const BETA_CHART_MARGIN = { ...CHART_MARGIN, top: 24 };

export const QuantityView = {
  AIRINGS: 'airings',
  SPEND: 'spend'
} as const;
export type QuantityViewType = (typeof QuantityView)[keyof typeof QuantityView];

export const QUANTITY_VIEW_OPTIONS = [
  { key: QuantityView.AIRINGS, label: 'Airings' },
  { key: QuantityView.SPEND, label: 'Spend' }
];
export const QUANTITY_VIEW_TOGGLE_WIDTH = 160;

const AIRINGS_BAR_SEGMENTS = 9;
const airingsGreenRamp = interpolateRgb(ScenarioDeltaGreen100, ScenarioDeltaGreen400);

// A light-to-dark green ramp for the airings meter, one color per segment.
export const AIRINGS_BAR_COLORS = Array.from({ length: AIRINGS_BAR_SEGMENTS }, (_value, i) =>
  airingsGreenRamp(i / (AIRINGS_BAR_SEGMENTS - 1))
);
